import { z } from "zod"

import type { HakiTone } from "~/server/api/routers/haki/types"

export type { HakiTone }

export const HAKI_TONE_DEFAULT: HakiTone = "balanced"

export const hakiToneSchema = z.enum(["concise", "balanced", "conversational"])

function readStoredTone(): HakiTone | null {
  try {
    // useSafeLocalStorage with crossCompany stores under "template-{key}"
    const raw = localStorage.getItem("template-hakiTone")
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    const result = hakiToneSchema.safeParse(parsed)
    return result.success ? result.data : null
  } catch {
    return null
  }
}

export const getHakiTone = (): HakiTone => readStoredTone() ?? HAKI_TONE_DEFAULT
